import * as CONSTANTS from '../../constants';

export default {

    /**
     * Indicates that the users are being fetched.
     *
     * @param state
     */
    [CONSTANTS.ADMIN_USERS_GET_PENDING] (state) {
        state.users = {...state.users, loading: true, noContent: false, error: false};
    },

    /**
     * Indicates that the users was successfully fetched.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.ADMIN_USERS_GET_SUCCESS] (state, payload) {
        state.users = {...state.users, loading: false, users: payload, noContent: false, error: false};
    },

    /**
     * Indicates that the users was unsuccessfully fetched.
     *
     * @param state
     */
    [CONSTANTS.ADMIN_USERS_GET_NOCONTENT] (state) {
        state.users = {...state.users, loading: false, users: undefined, noContent: true, error: false};
    },

    /**
     * Indicates that the were no users.
     *
     * @param state
     */
    [CONSTANTS.ADMIN_USERS_GET_FAILURE] (state) {
        state.users = {...state.users, loading: false, users: undefined, noContent: false, error: true};
    },

    /**
     * Indicates that the user is being fetched-
     *
     * @param state
     */
    [CONSTANTS.ADMIN_USER_GET_PENDING] (state) {
        state.users = {...state.users, loading: true, user: undefined, noContent: false, error: false};
    },

    /**
     * Indicates that the user was successfully fetched.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.ADMIN_USER_GET_SUCCESS] (state, payload) {
        state.users = {...state.users, loading: false, user: payload, noContent: false, error: false};
    },

    /**
     * Indicates that the user was unsuccessfully fetched.
     *
     * @param state
     */
    [CONSTANTS.ADMIN_USER_GET_NOCONTENT] (state) {
        state.users = {...state.users, loading: false, user: undefined, noContent: true, error: false};
    },

    /**
     * Indicates that there was no user.
     *
     * @param state
     */
    [CONSTANTS.ADMIN_USER_GET_FAILURE] (state) {
        state.users = {...state.users, loading: false, user: undefined, noContent: false, error: true};
    },

    /**
     * Toggle function for the create modal.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.ADMIN_USER_CREATE_MODAL_TOGGLE] (state, payload) {
        if(payload !== undefined) {
            state.createModal.open = payload;
        } else {
            state.createModal.open = !state.createModal.open;
        }
        // Reset the user object when modal is toggled
        state.createModal.user = {firstName: undefined, lastName: undefined, email: undefined, language: 'en', roles: []}
    },

    /**
     * Updates the values for the create user object.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.ADMIN_USER_CREATE_VALUES] (state, payload) {
        state.createModal.user = {...state.createModal.user, ...payload}
    },

    /**
     * Indicating that the create user was submitted.
     *
     * @param state
     */
    [CONSTANTS.ADMIN_FORM_CREATE_SUBMIT] (state) {
        state.createModal.form = {...state.createModal.form, submitted: true, accepted: false}
    },

    /**
     * Indicates that the create user submission was cancelled.
     * @param state
     */
    [CONSTANTS.ADMIN_FORM_CREATE_CANCEL] (state) {
        state.createModal.form = {...state.createModal.form, submitted: false, accepted: false}
    },

    /**
     * Indicates that the create user submission was accepted.
     *
     * @param state
     */
    [CONSTANTS.ADMIN_FORM_CREATE_ACCEPT] (state) {
        state.createModal.form = {...state.createModal.form, submitted: false, accepted: true}
    },

    /**
     * Inidicates that the create user is pending.
     *
     * @param state
     */
    [CONSTANTS.ADMIN_USER_CREATE_PENDING] (state) {
        state.createModal.form = {...state.createModal.form, error: false, loading: true, success: false}
    },

    /**
     * Indicates that the create user was successful.
     *
     * @param state
     */
    [CONSTANTS.ADMIN_USER_CREATE_SUCCESS] (state) {
        state.createModal.form = {...state.createModal.form, error: false, loading: false, success: true}
    },

    /**
     * Indicates that the create user failed.
     *
     * @param state
     */
    [CONSTANTS.ADMIN_USER_CREATE_FAILURE] (state) {
        state.createModal.form = {...state.createModal.form, error: true, loading: false, success: false}
    },

    /**
     * Toggle for the edit user modal.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.ADMIN_USER_EDIT_MODAL_TOGGLE] (state, payload) {
        if(payload !== undefined) {
            state.editModal.open = payload;
        } else {
            state.editModal.open = !state.editModal.open;
        }
    },

    /**
     * Update the edit user values.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.ADMIN_USER_EDIT_VALUES] (state, payload) {
        state.editModal.user = {...state.editModal.user, ...payload};
    },

    /**
     * Select the user to update.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.ADMIN_USER_SET] (state, payload) {
        // Clone user and set state
        state.editModal.originalUser = payload;
        state.editModal.user = payload;
    },

    /**
     * Unset the user selected.
     *
     * @param state
     */
    [CONSTANTS.ADMIN_USER_UNSET] (state) {
        state.editModal.originalUser = undefined;
        state.editModal.user = undefined;
    },

    /**
     * Indicates that the edit user was submitted.
     *
     * @param state
     */
    [CONSTANTS.ADMIN_FORM_EDIT_SUBMIT] (state) {
        state.editModal.form = {...state.editModal.form, submitted: true, accepted: false}
    },

    /**
     * Indicates that the submission was cancelled.
     *
     * @param state
     */
    [CONSTANTS.ADMIN_FORM_EDIT_CANCEL] (state) {
        state.editModal.form = {...state.editModal.form, submitted: false, accepted: false}
    },

    /**
     * Indicates that the submission was accepted.
     *
     * @param state
     */
    [CONSTANTS.ADMIN_FORM_EDIT_ACCEPT] (state) {
        state.editModal.form = {...state.editModal.form, submitted: false, accepted: true}
    },

    /**
     * Indicates that the edit user is pending.
     *
     * @param state
     */
    [CONSTANTS.ADMIN_USER_EDIT_PENDING] (state) {
        state.editModal.form = {...state.editModal.form, error: false, loading: true, success: false}
    },

    /**
     * Indicates that the edit user was successf.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.ADMIN_USER_EDIT_SUCCESS] (state) {
        state.editModal.form = {...state.editModal.form, error: false, loading: false, success: true}
    },

    /**
     * Indicate that the edit user failed.
     *
     * @param state
     */
    [CONSTANTS.ADMIN_USER_EDIT_FAILURE] (state) {
        state.editModal.form = {...state.editModal.form, error: true, loading: false, success: false}
    },

    /**
     * Indicates that the admin roles are being fetcehd.
     *
     * @param state
     */
    [CONSTANTS.ADMIN_ROLES_GET_PENDING] (state) {
        state.roles = {...state.roles, roles: undefined, loading: true, error: false, noContent: false}
    },

    /**
     * Indicates that the admin roles were successfully fetched.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.ADMIN_ROLES_GET_SUCCESS] (state, payload) {
        state.roles = {...state.roles, roles: payload, loading: false, error: false, noContent: false}
    },

    /**
     * Indicates that the admin roles were unsuccessfully fetched.
     *
     * @param state
     */
    [CONSTANTS.ADMIN_ROLES_GET_FAILURE] (state) {
        state.roles = {...state.roles, roles: undefined, loading: false, error: true, noContent: false}
    },

    /**
     * Indicates that the there were no admin roles fetched.
     *
     * @param state
     */
    [CONSTANTS.ADMIN_ROLES_GET_NO_CONTENT] (state) {
        state.roles = {...state.roles, roles: undefined, loading: false, error: false, noContent: true}
    },

    /**
     * Indicates that the languages pack is pending.
     *
     * @param state
     */
    [CONSTANTS.ADMIN_LANGUAGES_GET_PENDING] (state) {
        state.languages = {...state.languages, languages: undefined, loading: true, error: false, noContent: false}
    },

    /**
     * Indicates that the language pack is successfully fetched.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.ADMIN_LANGUAGES_GET_SUCCESS] (state, payload) {
        state.languages = {...state.languages, languages: payload, loading: false, error: false, noContent: false}
    },

    /**
     * Indicates that the language pack fetching failed.
     *
     * @param state
     */
    [CONSTANTS.ADMIN_LANGUAGES_GET_FAILURE] (state) {
        state.languages = {...state.languages, languages: undefined, loading: false, error: true, noContent: false}
    },

    /***
     * Indicates that there are no language packs available.
     *
     * @param state
     */
    [CONSTANTS.ADMIN_LANGUAGES_GET_NO_CONTENT] (state) {
        state.languages = {...state.roles, languages: undefined, loading: false, error: false, noContent: true}
    },

    /**
     * Decrement the timers for the create/edit success message.
     *
     * @param state
     */
    [CONSTANTS.ADMIN_COUNTDOWN_DECREMENT] (state) {
        // Only update the state if any of the timers are triggered
        if (state.createModal.timer > 0 || state.editModal.timer > 0) {
            state.createModal.timer--;
            state.editModal.timer--;
        }
    },

    /**
     * Sets the create modal timer to 10
     * @param state
     */
    [CONSTANTS.ADMIN_COUNTDOWN_CREATE_RESET] (state) {
        state.createModal.timer = 10;
    },

    /**
     * Sets the edit modal timer to 10
     * @param state
     */
    [CONSTANTS.ADMIN_COUNTDOWN_EDIT_RESET] (state) {
        state.editModal.timer = 10;
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/admin/mutations.js